const selection = {
    computed: {
        isMin() {
            const min = this.options.selectMin;
            return min && this.selectedCount < min;
        },
        isMax() {
            const max = this.options.selectMax;
            return max && this.selectedCount > max;
        },
        isExact() {
            const exact = this.options.selectExact;
            return exact && this.selectedCount === exact;
        },
    },
    methods: {
        async onUseSelected() {
            const callback = this.options.onUseSelected;
            if (callback & ({}.toString.call(callback) === '[object Function]')) {
                return new Promise((resolve, reject) => {
                    callback();
                })
                    .catch((error) => {
                        reject(error);
                    })
                    .then(() => {
                        resolve();
                    });
            }
        },
    },
};

export default selection;
